module.exports = __webpack_public_path__ + "static/media/temp-firetruck.9c04b1e7.jpg";